import { useAuth } from '../../shared/context';
import { CompanyExcludedLendersPage } from './CompanyExcludedLendersPage';
import { EmployeeExcludedLendersPage } from './EmployeeExcludedLendersPage';

export const ExcludedLenders: React.FC = () => {
	var auth = useAuth();

	return auth.currentUser.isEmployeeUser ? <EmployeeExcludedLendersPage /> : <CompanyExcludedLendersPage />;
};
